<ng-template #standardOrderButton>
  <button
    mat-raised-button
    color="primary"
    class="new-order-button"
    (click)="openNewOrderModal()"
    saAutomatedSelector="frac_detail_orders__new_orders"
  >
    <div class="new-order-button-inner">Order</div>
  </button>
</ng-template>

<!-- Admin, standard, and sand-coordinator roles get the standard order button -->
<ng-container *saAllowedAccountRoles="[1, 2, 9]">
  <ng-container *ngTemplateOutlet="standardOrderButton"></ng-container>
</ng-container>

<!-- Sand coordinators get a menu for new or replacement orders -->
<ng-container *saAllowedAccountRoles="[10]">
  <ng-container *saFeatureFlag="'orderReplacementByDispatcher'; else standardOrderButton">
    <button mat-raised-button color="primary" class="new-order-button" [matMenuTriggerFor]="newOrReplacementOrderMenu">
      <div class="new-order-button-inner">Order</div>
    </button>
    <mat-menu #newOrReplacementOrderMenu="matMenu">
      <button mat-menu-item (click)="openNewOrderModal()">
        New Order
      </button>
      <button mat-menu-item (click)="openReplacementOrderModal()">
        Replacement Order
      </button>
    </mat-menu>
  </ng-container>
</ng-container>
